import React from "react";
import { SelectInput } from "../../../../Forms/Inputs/DropdownSelect/React";
import InputWrapperWithHeading from "../../components/shared/inputWrapperWithHeading";
import { useTranslationContext } from "../../context";
import { FormSelectItem } from "../../types";

interface VeterinarianSelectProps {
  items: FormSelectItem[];
  selectedVetId: number;
  onSelectedChanged: (item: FormSelectItem) => void;
  visible: boolean;
}

export const VeterinarianSelect = ({
  items,
  selectedVetId,
  onSelectedChanged,
  visible
}: VeterinarianSelectProps) => {
  const translationContext = useTranslationContext();

  if (!visible) {
    return null;
  }

  return (
    <InputWrapperWithHeading
      id="selected-veterinarian"
      label={translationContext?.translations?.veterinarian}
      required={false}
      description={translationContext?.translations?.veterinarianDescription}
    >
      <SelectInput
        id="selected-veterinarian"
        buttonId="selected-veterinarian-button"
        items={items}
        title={translationContext?.translations?.veterinarian}
        name={translationContext?.translations?.veterinarian}
        placeholder={translationContext?.translations?.veterinarianPlaceholder}
        searchPlaceholder={translationContext?.translations?.searchToFilter}
        value={selectedVetId > 0 ? selectedVetId.toString() : ""}
        disabled={items.length === 0}
        onSelectedChanged={onSelectedChanged}
      />
    </InputWrapperWithHeading>
  );
};
